import { debounce, put } from 'redux-saga/effects';

import { Insurance } from 'constants/routes';
import * as CarInstanceConstants from 'store/carInstance/constants';
import * as InsuranceActions from 'store/insurance/actions';
import * as InsuranceConstants from 'store/insurance/constants';
import { CreatePage, WatchCarInstanceUpdate } from 'store/insurance/helpers';
import {
  insuranceStageGetApplication,
  insuranceStageGetCarInstance,
  insuranceStageGetInsuranceOrder,
  insuranceStageGetWorksheet,
  insuranceStageSelectBrand,
  insuranceStageSelectModel,
  insuranceStageSelectVersion,
  insuranceStageVinRecognition,
} from 'store/insurance/sagas';

const { ROUTE_NAMES } = Insurance;

const PAGE_NAME = ROUTE_NAMES.VEHICLE_INFORMATION;

const watchCarInstanceUpdate = new WatchCarInstanceUpdate();

export const insurancePageGetVehicleInformation = new CreatePage({
  action: InsuranceConstants.ACTIONS.GET_VEHICLE_INFORMATION,
  after: function* () {
    yield put(InsuranceActions.updatePagesLoadings({ [PAGE_NAME]: false }));

    watchCarInstanceUpdate.watch = true;
  },
  before: function* () {
    yield put(InsuranceActions.updatePagesLoadings({ [PAGE_NAME]: true }));
  },
  handler: function* ({ payload: worksheetId }, { runStage }) {
    yield* runStage(insuranceStageGetWorksheet, worksheetId);
    yield* runStage(insuranceStageGetInsuranceOrder);
    yield* runStage(insuranceStageGetApplication);
    yield* runStage(insuranceStageGetCarInstance);
    yield* runStage(insuranceStageSelectBrand);
    yield* runStage(insuranceStageSelectModel);
    yield* runStage(insuranceStageSelectVersion);
  },
  name: PAGE_NAME,
  watch: function* ({ watchSelfUpdate, watchStageUpdate }) {
    yield debounce(
      50,
      [
        CarInstanceConstants.ACTIONS.SET_CAR_INSTANCE,
        CarInstanceConstants.ACTIONS.UPDATE_NESTED_VALUES,
      ],
      watchCarInstanceUpdate.watcher.bind(watchCarInstanceUpdate)
    );

    yield watchSelfUpdate(function* ({ current, previous }) {
      const { [InsuranceConstants.PAGES_VALUE_FIELDS.WARNING]: currentWarning } = current ?? {};
      const { [InsuranceConstants.PAGES_VALUE_FIELDS.WARNING]: previousWarning } = previous ?? {};

      const {
        [InsuranceConstants.SHARED_ERROR_AND_WARNING_VALUE_FIELDS.TYPE]: currentWarningType,
      } = currentWarning ?? {};
      const {
        [InsuranceConstants.SHARED_ERROR_AND_WARNING_VALUE_FIELDS.TYPE]: previousWarningType,
      } = previousWarning ?? {};

      if (currentWarningType || currentWarningType === previousWarningType) {
        return;
      }

      yield put(
        InsuranceActions.updateStagesErrors({
          [CreatePage.getStageName(insuranceStageVinRecognition)]: currentWarning,
        })
      );
    });
    yield watchStageUpdate(
      insuranceStageVinRecognition,
      function* ({
        current: {
          [InsuranceConstants.STAGES_VALUE_FIELDS.ERROR]: error,
          [InsuranceConstants.STAGES_VALUE_FIELDS.LOADING]: loading,
        },
      }) {
        const { [InsuranceConstants.SHARED_ERROR_AND_WARNING_VALUE_FIELDS.TYPE]: errorType } =
          error;
        const patching = loading === InsuranceConstants.STAGES_LOADING_VALUES.LOADING;

        yield put(InsuranceActions.updatePagesPatching({ [PAGE_NAME]: patching }));

        if (errorType) {
          yield put(InsuranceActions.updatePagesWarnings({ [PAGE_NAME]: error }));
        }
      }
    );
  },
}).watcher;
